import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule, Provider } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

// Components
import { COMPONENT_DECLARATIONS } from "./components/component-map";
import { DynamicFieldDirective } from "./components/dynamic-field/dynamic-field.directive";
import { DynamicFormComponent } from "./containers/dynamic-form/dynamic-form.component";
// Directives
// Services
import { I18nPipe } from "./pipes/i18n.pipe";
import { DynamicFormsFactory } from "./services/dynamic-forms.factory";
import { FormFieldFactory } from "./services/form-field.factory";
import { I18nService } from "./services/i18n.service";
// Pipes
import { COMPONENT_MAP } from "./tokens";

export { COMPONENT_MAP } from "./tokens";

interface DynamicFormsModuleConfig {
	components?: Provider;
}

export function empty() {
	return new Map();
}

@NgModule({
	imports: [CommonModule, ReactiveFormsModule.withConfig({ callSetDisabledState: "whenDisabledForLegacyCode" })],
	declarations: [DynamicFormComponent, DynamicFieldDirective, I18nPipe, ...COMPONENT_DECLARATIONS],
	exports: [DynamicFormComponent],
})
export class DynamicFormsModule {
	static forRoot(config: DynamicFormsModuleConfig = {}): ModuleWithProviders<DynamicFormsModule> {
		return {
			ngModule: DynamicFormsModule,
			providers: [
				I18nService,
				I18nPipe,
				DynamicFormsFactory,
				FormFieldFactory,
				config.components || { provide: COMPONENT_MAP, useFactory: empty },
			],
		};
	}
}
